<template xmlns="http://www.w3.org/1999/html">
  <div class="footer">
    <div class="footer-content">
      <el-row :gutter="28">
        <el-col :span="9" style="margin-left: 20px;margin-top: 0px;">
          <p>Laboratory for</p>
          <p style="line-height: 20px">
            Bioinformatics | Analysis and Management of Biological Big Data |  Algorithms for Mining Genomic Sequencing Data | Systematic Analysis of Single-Cell Data | Artificial Intelligence in Medicine | Translational Medical Informatics
          </p>
        </el-col>
        <el-col :span="8">
          <div style="height: 200px;margin-top: 0px;">
            <p>Contact us:</p>
            <p style="line-height: 20px">
              <a>Professor: Guohua Wang</a><br>
              <a>Address: Northeast Forestry University, Harbin 150040, China</a><br>
              <a>Mail: ghwang@nefu.edu.cn</a>
            </p>
          </div>
        </el-col>
        <el-col :span="6">
          <BMap id="bdMap" ak="eA96Z8BkClroGf30LPwEmxnlepsnQQdk" center="哈尔滨市香坊区和兴路26号" height="200px" width="100%" lang="en"></BMap>
        </el-col>
      </el-row>
    </div>
    <div style="background-color: white;height: 1px"></div>
    <div class="footer-bottom">
      <el-row :gutter="10">
        <el-col>
          <div style="margin: 1% 3%;text-align: center;">
            <p>Copyright © Bio Laboratory | HEI ICP 19004777</p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { BMap } from 'vue3-baidu-map-gl'
export default {
  name: "Footer_page",

}
</script>

<style scoped>
.footer{
  margin-top: 0;
  padding: 15px 0;
}
.footer-content{
  /*border-top: 2px silver solid;*/
  /*border-left: 2px silver solid;*/
  /*border-right: 2px silver solid;*/
  color: white;
  width: 100%;
  margin: auto;
  background-color: #2185d0;
}
#bdMap{
  margin: 20px;
  width: 100%;
  height: 200px;
}
.footer-bottom{
  background-color: #2185d0;
  width: 100%;
  margin: auto;
  color: white;
}
</style>
